import { ComponentProps } from "../registry";
import { useBound } from "../helpers";
import { BoundValue } from "../../types";

export function Divider({ fields, scope }: ComponentProps) {
  const axis = useBound<string>(fields.axis as BoundValue, scope) ?? "horizontal";
  return <div className={`a2-divider axis-${axis}`} role="separator" />;
}
